module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rptMenu",
    on: {
      "blur": function($event) {
        return _vm.blurMenu()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOpened),
      expression: "!isOpened"
    }],
    staticClass: "fa fa-sort-desc",
    on: {
      "click": function($event) {
        _vm.isOpened = true
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpened),
      expression: "isOpened"
    }],
    staticClass: "rptMenuList"
  }, [_c('i', {
    staticClass: "fa fa-times rptMenu",
    staticStyle: {
      "top": "0px"
    },
    on: {
      "click": function($event) {
        _vm.isOpened = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rptMenuItems"
  }, [_c('span', {
    staticClass: "text-sm"
  }, [_vm._v("Label:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mDataItem),
      expression: "mDataItem"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mDataItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dataItems), function(dataItem) {
    return _c('option', {
      domProps: {
        "value": dataItem.fieldName
      }
    }, [_vm._v(_vm._s(dataItem.label))])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "text-sm"
  }, [_vm._v("Data Item:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mDataItem),
      expression: "mDataItem"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mDataItem = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dataItems), function(dataItem) {
    return _c('option', {
      domProps: {
        "value": dataItem.fieldName
      }
    }, [_vm._v(_vm._s(dataItem.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "text-sm"
  }, [_vm._v("Text Align:")]), _vm._v(" "), _c('ul', {
    staticClass: "pagination pagination-sm",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('li', [_c('a', {
    class: ['noselect', _vm.elmData.align === 'left' ? 'activePage' : ''],
    on: {
      "click": function($event) {
        _vm.elmData.align = 'left'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    class: ['noselect', _vm.elmData.align === 'center' ? 'activePage' : ''],
    on: {
      "click": function($event) {
        _vm.elmData.align = 'center'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    class: ['noselect', _vm.elmData.align === 'right' ? 'activePage' : ''],
    on: {
      "click": function($event) {
        _vm.elmData.align = 'right'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('span', {
    staticClass: "text-sm"
  }, [_vm._v("Font Weight:")]), _vm._v(" "), _c('ul', {
    staticClass: "pagination pagination-sm",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('li', [_c('a', {
    class: ['noselect', _vm.elmData.bold ? 'activePage' : ''],
    on: {
      "click": function($event) {
        _vm.elmData.bold = true
      }
    }
  }, [_vm._v("\n              Bold\n            ")])]), _vm._v(" "), _c('li', [_c('a', {
    class: ['noselect', !_vm.elmData.bold ? 'activePage' : ''],
    on: {
      "click": function($event) {
        _vm.elmData.bold = false
      }
    }
  }, [_vm._v("\n              None\n            ")])])])]), _vm._v(" "), _c('span', {
    staticClass: "text-sm"
  }, [_vm._v("Font Size:")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mFontSize),
      expression: "mFontSize"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mFontSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeFontSize]
    }
  }, _vm._l((_vm.fontSizeList), function(fontSize) {
    return _c('option', {
      domProps: {
        "value": fontSize
      }
    }, [_vm._v(_vm._s(fontSize))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "border-top": "1px solid #ddd"
    }
  }, [_c('a', {
    staticClass: "noselect",
    staticStyle: {
      "font-size": "12px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('removeClicked', _vm.index)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" Remove Item\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a537a296!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/ReportMenu.vue
// module id = 744
// module chunks = 0